import { render, staticRenderFns } from "./NewFormDocument.vue?vue&type=template&id=cf174438"
import script from "./NewFormDocument.vue?vue&type=script&lang=js"
export * from "./NewFormDocument.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports